<template>
  <header class="site-header">
    <div class="container">
      <div class="row">
        <div class="col-6 my-auto">
          <router-link to="/">
            <img src="@/assets/logo.svg" class="header-logo" alt />            
          </router-link>
          <span class="environment" v-if="environment == 'DEV'">
            DEV
          </span>
        </div>
        <div v-if="!user" class="col-6 text-right">
          <router-link class="btn btn-primary btn-md" to="/sign-up">
            Create your report
          </router-link>
        </div>
        <div v-if="user" class="col-6 header-actions text-right">
          <div class="icon-actions">
            <button
              v-if="this.$route.name !== 'testpersonality'"
              class="dropdown-container"
              v-on:click="toggle('notifications')"
              v-bind:class="{ open: dropDowns.notifications }"
              id="notifications"
              title="Profile"
            >
              <div class="icon-link dropdown-toggle">
                <span
                  v-if="getNotifications && newNotifications"
                  class="counter"
                  >{{ newNotifications }}</span
                >
                <font-awesome-icon icon="bell" />
              </div>
              <div class="dropdown-menu notifications">
                <perfect-scrollbar class="notification-list">
                  <div
                    v-bind:key="item.id"
                    v-for="item in getNotifications"
                    class="item"
                    v-bind:class="{ seen: item.seen }"
                    @click="notificationAction(item)"
                  >
                    <div class="content">{{ item.content }}</div>
                    <div class="indicator">
                      <span></span>
                    </div>
                  </div>
                  <div v-if="!getNotifications.length" class="item seen">
                    You have no notifications
                  </div>
                  <div
                    v-if="getNotifications.length && !clearingNotifications"
                    class="clear-notifications"
                    @click="clearNotifications()"
                  >
                    Clear all notifications
                  </div>
                </perfect-scrollbar>
              </div>
            </button>
            <button
              v-if="this.$route.name !== 'testpersonality'"
              class="dropdown-container pending-friends"
              v-on:click="$toggleFriendsModal()"
            >
              <div class="icon-link dropdown-toggle">
                <font-awesome-icon icon="users" />
                <span v-if="pendingFriends.length" class="counter">{{
                  pendingFriends.length
                }}</span>
              </div>
            </button>
          </div>
          <button
            class="dropdown-container"
            id="profile"
            v-on:click="toggle('profile')"
            v-bind:class="{ open: dropDowns.profile }"
          >
            <div class="dropdown-toggle">
              <span class="profile-toggle">
                <UserAvatar />
              </span>
            </div>
            <ul class="dropdown-menu link-items profile">
              <li class="item">
                <router-link to="/">Dashboard</router-link>
              </li>
              <div class="item-wrap">
                <span class="item-title">Personality</span>
                <li v-if="!getUserData.personality" class="item">
                  <router-link to="/test/personality"
                    >Start assessment</router-link
                  >
                </li>
                <li v-if="getUserData.personality" class="item">
                  <router-link to="/results/personality"
                    >View results</router-link
                  >
                </li>
              </div>
              <div class="item-wrap">
                <span class="item-title">Pathways</span>
                <li v-if="!getUserData.pathways" class="item">
                  <router-link to="/test/pathways"
                    >Start assessment</router-link
                  >
                </li>
                <li v-if="getUserData.pathways" class="item">
                  <router-link to="/results/pathways"
                    >View results</router-link
                  >
                </li>
              </div>
              <li class="item">
                <router-link to="/profile">Profile</router-link>
              </li>
              <li class="item">
                <a href="#" @click="$toggleFriendsModal()">Friends</a>
              </li>
              <li class="item blue">
                <a href="https://forms.gle/G2BNiMHne83q8geu7" target="_blank">Feedback</a>
              </li>              
              <li class="item">
                <a href="#" @click="$signOut()">Sign out</a>
              </li>
            </ul>
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
// FireBase
import firebase from "firebase/app";
import "firebase/auth";
import { db } from "../main.js";
import UserAvatar from "@/components/UserAvatar.vue";

var _ = require("lodash");

import { mapState } from "vuex";

function hasClass(element, className) {
  var regex = new RegExp("\\b" + className + "\\b");
  do {
    if (regex.exec(element.className)) {
      return true;
    }
    element = element.parentNode;
  } while (element);
  return false;
}

function getTree(element) {
  var regex = new RegExp("\\b" + "dropdown-container" + "\\b");
  do {
    if (regex.exec(element.className)) {
      return element.id;
    }
    element = element.parentNode;
  } while (element);
  return false;
}

export default {
  name: "AppHeader",
  components: { UserAvatar },
  computed: {
    ...mapState(["user"]),
    ...mapState(["userData"]),
    ...mapState(["friends"]),
    ...mapState(["notifications"]),
    getUser() {
      return this.user ? this.user : "";
    },
    getUserData() {
      return this.userData ? this.userData : "";
    },
    getFriends() {
      return this.friends ? this.friends : "";
    },
    getNotifications() {
      return this.notifications ? this.notifications : "";
    },
    pendingFriends() {
      return _.filter(this.getFriends, { status: false, inviter: false });
    },
    newNotifications() {
      if (this.notifications) {
        let count = 0;
        this.notifications.forEach(element => {
          if (element.seen == false) {
            count++;
          }
        });
        return count;
      } else {
        return 0;
      }
    }
  },
  data() {
    return {
      dropDowns: {
        profile: false,
        notifications: false
      },
      clearingNotifications: false,
      environment: null
    };
  },
  mounted: function() {
    this.environment = process.env.VUE_APP_ENV;
    var self = this;
    window.addEventListener(
      "click",
      function(e) {
        if (!hasClass(e.target, "dropdown-container")) {
          self.closeDropdowns();
        } else if (hasClass(e.target, "dropdown-container")) {
          let tgt = getTree(e.target);
          if (tgt === "profile") {
            self.dropDowns.notifications = false;
          } else if (tgt === "notifications") {
            self.dropDowns.profile = false;
          }
        }
      },
      false
    );
  },
  methods: {
    notificationAction: function(notification) {
      const userData = this.getUser;
      const nid = notification.id;
      const uid = userData.uid;

      if (notification && !notification.seen) {
        const data = {
          seen: true
        };

        if (uid) {
          db.collection("users")
            .doc(uid)
            .collection("notifications")
            .doc(nid)
            .update(data)
            .then(() => {})
            .catch(error => {
              this.$errorMessage(error.message);
            });
        }
      }
      if (notification.action) {
        if (notification.path === "friends") {
          this.$toggleFriendsModal()
        } else {
          this.$router.replace({ path: notification.path });
        }
      }
    },
    toggle: function(dropdownName) {
      this.dropDowns[dropdownName] = !this.dropDowns[dropdownName];
    },
    closeDropdowns() {
      this.dropDowns.profile = false;
      this.dropDowns.notifications = false;
    },
    clearNotifications: function() {
      if (this.clearingNotifications) {
        return false;
      }
      this.clearingNotifications = true;
      let removeNotifications = firebase
        .functions()
        .httpsCallable("removeNotifications");

      removeNotifications()
        .then(() => {
          this.clearingNotifications = false;
        })
        .catch(error => {
          console.log(error);
          this.clearingNotifications = false;
        });
    },
  }
};
</script>
